import Swal from 'sweetalert2';
import getGuests from "./get-guests";
import hasRental_prop_persons from "./has-rental_prop_persons";
import refreshGuestData from "./refresh-guest-data";

class GuestList {
    constructor() {
        this.guestList = [];
        this.possibleGuests = [];
        this.maxGuests = 0;
        this.quantityElement = false;
        this.formType = 'reserve';
        this.hasGuests = false;
        this.refresh();
    }

    setFormType(formType) {
        this.formType = 'reserve';

        if (formType == 'user_modification') {
            this.formType = 'modify';
        }
    }

    refresh() {
        this.quantityElement = hasRental_prop_persons();
        this.maxGuests = 0;
        if (!this.quantityElement) {
            return;
        }
        for (let index = 0, len = this.quantityElement.options.length; index < len; index++) {
            if (parseInt(this.quantityElement.options[index].value) > this.maxGuests) {
                this.maxGuests = parseInt(this.quantityElement.options[index].value);
            }
        }

        // if (this.maxGuests == 0) {
        //     console.log("Pushing --- onto start");
        //     this.guestList.push({
        //         name: '---',
        //         email: '---',
        //         vehicle_no: '---',
        //         cnaq_id: '---',
        //         id: '---',
        //         category: '---',
        //     });
        //     return;
        // }

        // Detect any already added guests
        this.guestList = [];
        let name,email,vehicle_no,cnaq_id,guest_id,guest_category,labelValue;
        for (let index = 0; index < this.maxGuests; index++) {
            name = document.querySelector('#rental_prop_Guest_name_' + (index + 1)).value;
            email = document.querySelector('#rental_prop_Guest_email_' + (index + 1)).value;
            vehicle_no = document.querySelector('#rental_prop_Vehicle_number_' + (index + 1)).value;
            cnaq_id = document.querySelector('#rental_prop_CNA_Q_ID_' + (index + 1)).value;
            guest_id = parseInt(document.querySelector('#rental_prop_Guest_ID_' + (index + 1)).value);
            guest_category = document.querySelector('#rental_prop_Guest_category_' + (index + 1)).value;
            labelValue = document.querySelector('#row_rental_prop_CNA_Q_ID_' + (index + 1) + ' label');
            labelValue.innerHTML = 'UDST ID';
            // If there's an entry but it doesn't have a guest ID, then add it as a user entered guest
            if (!isNaN(guest_id) && guest_id > 0 && (name != '' || email != '' || vehicle_no != '' || cnaq_id != '') && guest_category != '---') {
                // console.log("Something isn't empty", {
                //     name: name,
                //     email: email,
                //     vehicle_no: vehicle_no,
                //     cnaq_id: cnaq_id,
                //     user_added: true
                // });
                this.guestList.push({
                    name: name,
                    email: email,
                    vehicle_no: vehicle_no,
                    cnaq_id: cnaq_id,
                    id: guest_id,
                    category: guest_category,
                });
            }
        }

        // if (this.guestList.length == 0) {
        //     this.quantityElement.selectedIndex = 0;
        //     this.guestList.push({
        //         name: '---',
        //         email: '---',
        //         vehicle_no: '---',
        //         cnaq_id: '---',
        //         id: '---',
        //         category: '---',
        //     });
        //     return;
        // }

        // console.log('guest list after refresh', this.guestList);
    }

    /**
     * Is the guest already on the form
     * @param {Guest} guest
     */
    isGuestAlreadyAdded(guest) {
        if (typeof guest.id == 'undefined') {
            return false;
        }
        let guestOnList;
        for (let index = 0, len = this.guestList.length; index < len; index++) {
            guestOnList = this.guestList[index];
            if (guestOnList.id == guest.id) {
                return true;
            }
        }
        return false;
    }

    /**
     * Replace original guest object in this.possibleGuests with the updated guest data
     *
     * @param {Guest} originalGuest
     * @param {Guest} updatedGuest
     */
    updatedPossibleGuest(originalGuest, updatedGuest) {
        // console.log('updatedPossibleGuest', updatedGuest);
        let possibleGuest;
        for (let index = 0, len = this.possibleGuests.length; index < len; index++) {
            possibleGuest = this.possibleGuests[index];
            if (possibleGuest.id == originalGuest.id) {
                // console.log('replacing ', index, possibleGuest, updatedGuest);
                this.possibleGuests[index] = updatedGuest;
                // console.log(this.possibleGuests);
                return;
            }
        }
        this.possibleGuests.push(updatedGuest);
        // console.log('pushing on end', this.possibleGuests);
    }

    ensureGuestDetailsAreUpToDate(guest) {
        return new Promise((resolve, reject) => {
            refreshGuestData(guest)
                .then(updatedGuest => {
                    const status = (typeof updatedGuest.status !== 'undefined') ? updatedGuest.status : '';
                    if (status == 'ok') {
                        this.updatedPossibleGuest(guest, updatedGuest.guest);
                        resolve(updatedGuest.guest);
                        return;
                    }

                    if (status == 'deleted') {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Sorry, that guest is no longer valid',
                            text: 'The guest in no longer an internal CNA-Q user and has been removed',
                        });
                        guestList.possibleGuests = getGuests();
                        guestList.refresh();
                        reject();
                        return;
                    }

                    if (status == 'min_data') {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Sorry, that guest is no longer valid',
                            text: "The guest is an internal CNA-Q user but doesn't have required fields filled in and has been removed",
                        });
                        guestList.possibleGuests = getGuests();
                        guestList.refresh();
                        reject();
                        return;
                    }

                    resolve(updatedGuest.guest);
                })
                .catch(error => {
                    console.error(error);
                    reject();
                });
        });
    }

    findGuestById(id) {
        let guest;
        // console.log('looking for', id, this.possibleGuests);
        for (let index = 0, len = this.possibleGuests.length; index < len; index++) {
            guest = this.possibleGuests[index];
            if (guest.id == id) {
                return guest;
            }
        }
        return false;
    }

    addGuest(guest) {
        if (typeof guest.id == 'undefined') {
            console.error('addGuest() must be passed a valid guest ', guest);
            return false;
        }

        return this.addGuestById(guest.id);
    }

    addGuestById(id) {
        return new Promise((resolve, reject) => {
            this.refresh();
            if (this.guestList.length >= this.maxGuests) {
                reject('Maximum guest limit');
            }

            const guest = this.findGuestById(id);

            if (guest === false) {
                console.error('Unable to find guest with ID ', id);
                return false;
            }

            if (this.isGuestAlreadyAdded(guest)) {
                console.error('Guest is already added ', id);
                return guest;
            }

            this.ensureGuestDetailsAreUpToDate(guest)
            .then(guest => {
                this.guestList.push(guest);
                this.handleEmptyGuestList();
                this.guestListUpdated();
                resolve(guest);
            })
            .catch(rejectReason => {
                reject();
            });
        })
    }

    removeGuestById(id) {
        this.refresh();
        const guest = this.findGuestById(id);

        if (guest === false) {
            console.error('Unable to find guest with ID ', id);
            return false;
        }

        let newGuestList = [], guestOnList;
        for (let index = 0, len = this.guestList.length; index < len; index++) {
            guestOnList = this.guestList[index];
            if (guestOnList.id != guest.id) {
                newGuestList.push(guestOnList);
            }
        }

        this.guestList = newGuestList;
        this.handleEmptyGuestList();
        this.guestListUpdated();
        // console.log('guestList', this.guestList);
        return guest;
    }

    /**
     * If the guest list is empty, fill the first guest with ---
     */
    handleEmptyGuestList() {
        if (this.guestList.length == 0) {
            this.hasGuests = false;
            return false;
        }
        if (this.guestList.length == 1 && typeof this.guestList[0] !== 'undefined' && typeof this.guestList[0].id !== 'undefined' && this.guestList[0].id == '---') {
            this.hasGuests = false;
            return false;
        }
        this.hasGuests = true;
        return true;
    }

    /**
     * Render the current guestList contents into the Planyo form
     */
    guestListUpdated() {
        let numGuests = 0;
        let guest;
        let counts = {
            'Family of Employee': 0,
            'Student': 0,
            'Faculty': 0,
            'Staff': 0,
            'Alumni': 0,
            'Public': 0,
        };
        for (let index = 0; index < this.maxGuests; index++) {
            document.querySelector('#rental_prop_Guest_name_' + (index + 1)).setAttribute('readonly', true);
            document.querySelector('#rental_prop_Guest_email_' + (index + 1)).setAttribute('readonly', true);
            document.querySelector('#rental_prop_Vehicle_number_' + (index + 1)).setAttribute('readonly', true);
            document.querySelector('#rental_prop_CNA_Q_ID_' + (index + 1)).setAttribute('readonly', true);
            document.querySelector('#rental_prop_National_ID_' + (index + 1)).setAttribute('readonly', true);
            document.querySelector('#rental_prop_Guest_ID_' + (index + 1)).setAttribute('readonly', true);
            document.querySelector('#rental_prop_Guest_category_' + (index + 1)).setAttribute('readonly', true);
            document.querySelector('#rental_prop_Guest_List_' + (index + 1)).classList.remove('guest-list__visible');
            document.querySelector('#row_rental_prop_CNA_Q_ID_' + (index + 1) + ' label').innerHTML = 'UDST ID';

            if (this.hasGuests && typeof this.guestList[index] !== 'undefined') {
                // console.log('something in index ', index, this.guestList[index]);
                guest = this.guestList[index];
                document.querySelector('#rental_prop_Guest_name_' + (index + 1)).value = guest.name;
                document.querySelector('#rental_prop_Guest_email_' + (index + 1)).value = guest.email;
                document.querySelector('#rental_prop_Vehicle_number_' + (index + 1)).value = guest.vehicle_no || '';
                document.querySelector('#rental_prop_CNA_Q_ID_' + (index + 1)).value = guest.cnaq_id || '';
                document.querySelector('#rental_prop_National_ID_' + (index + 1)).value = '---';
                document.querySelector('#rental_prop_Guest_category_' + (index + 1)).value = guest.category || '';
                document.querySelector('#rental_prop_Guest_ID_' + (index + 1)).value = guest.id || '';
                document.querySelector('#rental_prop_Guest_List_' + (index + 1)).classList.add('guest-list__visible');
                if (guest.id == '---') {
                    continue;
                }
                if (typeof counts[guest.category] == 'undefined') {
                    console.error("Undefined count index", guest);
                    counts[guest.category] = 0;
                }
                // console.log('counting', this.guestList[index]);
                numGuests++;
                counts[guest.category]++;
                continue;
            }

            document.querySelector('#rental_prop_Guest_name_' + (index + 1)).value = '';
            document.querySelector('#rental_prop_Guest_email_' + (index + 1)).value = '';
            document.querySelector('#rental_prop_Vehicle_number_' + (index + 1)).value = '';
            document.querySelector('#rental_prop_CNA_Q_ID_' + (index + 1)).value = '';
            document.querySelector('#rental_prop_National_ID_' + (index + 1)).value = '---';
            document.querySelector('#rental_prop_Guest_ID_' + (index + 1)).value = '';
            document.querySelector('#rental_prop_Guest_category_' + (index + 1)).value = '';
        }

        // If it's an empty guest list, fill the first value with ---
        if (this.hasGuests === false) {
            this.guestList = [];
            this.guestList.push({
                name: '---',
                email: '---',
                vehicle_no: '---',
                national_id: '---',
                cnaq_id: '---',
                id: '---',
                category: '---',
            });
            document.querySelector('#rental_prop_Guest_name_1').value = '---';
            document.querySelector('#rental_prop_Guest_email_1').value = '---';
            document.querySelector('#rental_prop_Vehicle_number_1').value = '---';
            document.querySelector('#rental_prop_CNA_Q_ID_1').value = '---';
            document.querySelector('#rental_prop_National_ID_1').value = '---';
            document.querySelector('#rental_prop_Guest_category_1').value = '---';
            document.querySelector('#rental_prop_Guest_ID_1').value = '---';
            document.querySelector('#rental_prop_Guest_List_1').style.display = 'none';
            document.querySelector('#rental_prop_Guest_List_1').classList.remove('guest-list__hidden');
        } else {
            document.querySelector('#rental_prop_Guest_List_1').style.display = 'block';
            document.querySelector('#rental_prop_Guest_List_1').classList.add('guest-list__visible');
        }

        document.querySelector('#rental_prop_Count_Guest_Staff').value = counts.Staff;
        document.querySelector('#rental_prop_Count_Guest_Faculty').value = counts.Faculty;
        document.querySelector('#rental_prop_Count_Guest_Student').value = counts.Student;
        document.querySelector('#rental_prop_Count_Guest_Alumni').value = counts.Alumni;
        document.querySelector('#rental_prop_Count_Guest_Public').value = counts.Public;
        document.querySelector('#rental_prop_Count_Guest_Family_of_employee').value = counts['Family of Employee'];

        if (this.quantityElement === false) {
            return;
        }

        if (numGuests == 0) {
            this.quantityElement.value = 'none';
        } else {
            this.quantityElement.value = numGuests;
        }

        if (typeof window.js_dates_changed !== 'undefined') {
            window.js_dates_changed();
        }
    }
}

const guestList = new GuestList;

export default guestList;